import { render } from "./NovaContratacaoView.vue?vue&type=template&id=e09784ba&scoped=true"
import script from "./NovaContratacaoView.vue?vue&type=script&lang=js"
export * from "./NovaContratacaoView.vue?vue&type=script&lang=js"

import "./NovaContratacaoView.vue?vue&type=style&index=0&id=e09784ba&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e09784ba"]])

export default __exports__